import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Theme } from '@material-ui/core';

import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { PageBody } from '../../components/PageBody';
import { TextField } from '../../components/TextField';
import { Button } from '../../components/Button';
import { ChangePasswordRequestData } from '../../api/resetPassword';
import { FormGroup } from '../../components/FormGroup';
import { api } from '../../api';
import { useLoading } from '../../units/loading';
import { useAlert } from '../../units/alert';
import { StatusFalseError } from '../../api/error/StatusFalseError';
import { usePartner } from '../../hooks/usePartner';

type ChangePasswordPageProps = {};

ChangePasswordPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

function ChangePasswordPage(props: ChangePasswordPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const { setIsLoading } = useLoading();
    const alert = useAlert();
    const [formData, setFormData] = useState<ChangePasswordRequestData>({
        type: '1',
        login: '',
        password: '',
        password_bef: '',
    });
    const { partner, isLoading: isPartnerLoading } = usePartner();
    const [confirmPassword, setConfirmPassword] = useState('');

    useEffect(() => {
        setIsLoading(isPartnerLoading);
    }, [isPartnerLoading]);

    function handleSubmitClick() {
        setIsLoading(true);
        api.changePassword({
            ...formData,
            login: partner?.email || '',
        })
            .then(() => {
                setIsLoading(false);
                alert.show({
                    type: 'success',
                    title: '操作成功',
                    message: '已成功修改密碼',
                });
                history.replace('/member/action');
            })
            .catch(async (e) => {
                setIsLoading(false);
                if (e instanceof StatusFalseError) {
                    const errorData = await e.response.json();
                    alert.show({
                        type: 'error',
                        title: '錯誤',
                        message: errorData.msg,
                    });
                }
            });
    }

    function canSubmit() {
        return formData.password_bef
            && formData.password
            && formData.password === confirmPassword;
    }

    function isConfirmPasswordPass() {
        return (confirmPassword && formData.password) && (confirmPassword === formData.password);
    }

    return (
        <Page>
            <BackAppBar title="修改密碼" onBackClick={() => history.replace('/member/action')} />
            <PageBody>
                <FormGroup>
                    <TextField
                        label="目前密碼"
                        type="password"
                        value={formData.password_bef}
                        onChange={(e) => setFormData({
                            ...formData,
                            password_bef: e.target.value,
                        })}
                        required
                    />
                    <TextField
                        label="輸入新密碼"
                        type="password"
                        onChange={(e) => setFormData({
                            ...formData,
                            password: e.target.value,
                        })}
                        required
                    />
                    <TextField
                        label="確認新密碼"
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                        error={Boolean(confirmPassword && formData.password) && !isConfirmPasswordPass()}
                        helperText={Boolean(confirmPassword && formData.password) && !isConfirmPasswordPass() ? '密碼與確認新密碼不同' : ''}
                    />
                    <Button onClick={handleSubmitClick} disabled={!canSubmit()}>送出修改</Button>
                </FormGroup>
            </PageBody>
        </Page>
    );
}

export { ChangePasswordPage };
